// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a.navbar-brand {
  padding-left: 43px;
  position: relative;
}
a.navbar-brand object {
  position: absolute;
  left: 0;
  top: 3px;
  z-index: -1;
  /*Fix for logo to be clickable*/
}
.loggedInfo {
  color: white;
  padding-top: 9px;
}
#repositorySelectDropdown .fa {
  color: #fff;
}
#repositorySelectDropdown.open > .popover {
  display: none !important;
}
#repositorySelectDropdown li .popover .popover-title {
  padding: 4px 14px;
}
#repositorySelectDropdown li .popover .popover-content {
  padding: 6px 14px;
}
#repositorySelectDropdown li .popover label {
  margin-bottom: 3px;
}
#menu-active-location {
  max-width: 146px;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: default;
  margin-bottom: -4px;
  font-size: 0.9em;
  padding-left: 5px;
}
@media (min-width: 1030px) {
  #menu-active-location {
    max-width: 180px;
  }
}
@media (min-width: 1080px) {
  #menu-active-location {
    max-width: 230px;
  }
}
@media (min-width: 1130px) {
  #menu-active-location {
    max-width: 280px;
  }
}
@media (min-width: 1180px) {
  #menu-active-location {
    max-width: 330px;
  }
}
@media (min-width: 1230px) {
  #menu-active-location {
    max-width: 380px;
  }
}
@media (min-width: 1280px) {
  #menu-active-location {
    max-width: 430px;
  }
}
@media (min-width: 1440px) {
  #menu-active-location {
    max-width: 520px;
  }
}
.activeRepositorySYSTEM > .popover {
  width: 250px;
}
.activeRepositorySYSTEM > .popover .popover-title {
  display: none;
}
.activeRepositorySYSTEM > .popover .popover-content .row {
  display: none;
}
.activeRepositorySYSTEM > .popover .popover-content .row:first-child {
  display: block;
}
.chooseRepository > .popover {
  display: none !important;
}
.activeRepository > .popover {
  width: 250px;
}
.popover {
  z-index: 2060;
}
[ng-cloak] + .show-ng-cloak {
  display: block !important;
}
.wb-pointer {
  cursor: pointer;
}
.wb-home-data h4 {
  color: #000;
}
td .editable-wrap {
  display: inline;
}
.navbar-fixed-top .container > .navbar-header,
.navbar-fixed-top .container > .navbar-collapse {
  margin-right: 0;
  margin-left: 0;
  display: block;
  border-top: 0;
}
.navbar-fixed-top .navbar-header,
.navbar-fixed-top .navbar-nav,
.navbar-fixed-top .navbar-nav > li {
  float: left;
}
.navbar-fixed-top .navbar-nav.navbar-right {
  float: right;
  margin-right: -15px;
}
.navbar-fixed-top .navbar-nav .open .dropdown-menu {
  position: absolute;
  background-color: var(--gw-secondary-base);
}
.navbar-fixed-top .navbar-nav > li > a {
  padding-top: 12px;
  padding-bottom: 12px;
}
.navbar-fixed-top .navbar-text {
  margin-left: 15px;
}
.navbar-nav {
  margin: 0;
}
.navbar-button {
  color: white;
  padding-left: 7px !important;
  padding-right: 7px !important;
  padding-top: 12px !important;
  padding-bottom: 12px !important;
  text-decoration: none;
  background-color: var(--gw-secondary-base);
  display: inline-block !important;
  margin-left: 7px;
}
.navbar-button:hover {
  text-decoration: none;
  background-color: var(--gw-tertiary-base);
}
.autocomplete-toast a,
.autocomplete-toast a:hover {
  background-color: var(--gw-toast-warn-background) !important;
  border-color: var(--gw-toast-warn-border-color) !important;
  color: var(--gw-toast-warn-color) !important;
  cursor: pointer;
}
/*# sourceMappingURL=owlim-workbench.css.map */`, "",{"version":3,"sources":["webpack://./owlim-workbench.less","webpack://./packages/legacy-workbench/src/less/owlim-workbench.less"],"names":[],"mappings":"AAkBA;EACC,kBAAA;EACA,kBAAA;ACjBD;ADeA;EAIE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EChBA,+BAA+B;AACjC;ADmBA;EACC,YAAA;EACA,gBAAA;ACjBD;ADoBA;EAEI,WAAA;ACnBJ;ADqBE;EACE,wBAAA;ACnBJ;ADcA;EASM,iBAAA;ACpBN;ADWA;EAYM,iBAAA;ACpBN;ADQA;EAeM,kBAAA;ACpBN;ADyBA;EACE,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;ACvBF;ADyBE;EAAA;IACE,gBAAA;ECtBF;AACF;ADwBE;EAAA;IACE,gBAAA;ECrBF;AACF;ADuBE;EAAA;IACE,gBAAA;ECpBF;AACF;ADsBE;EAAA;IACE,gBAAA;ECnBF;AACF;ADqBE;EAAA;IACE,gBAAA;EClBF;AACF;ADoBE;EAAA;IACE,gBAAA;ECjBF;AACF;ADmBE;EAAA;IACE,gBAAA;EChBF;AACF;ADoBE;EACE,YAAA;AClBJ;ADiBE;EAGI,aAAA;ACjBN;ADcE;EAMI,aAAA;ACjBN;ADkBM;EACE,cAAA;AChBR;ADqBA;EACE,wBAAA;ACnBF;ADqBA;EACE,YAAA;ACnBF;ADuBA;EACI,aAAA;ACrBJ;ADyBA;EACC,yBAAA;ACvBD;AD0BA;EACE,eAAA;ACxBF;AD2BA;EACE,WAAA;ACzBF;AD4BA;EACC,eAAA;AC1BD;AD6BA;;EACE,eAAA;EACA,cAAA;EACA,cAAA;EACA,aAAA;AC1BF;AD4BA;;;EACE,WAAA;ACxBF;AD0BA;EACE,YAAA;EACA,mBAAA;ACxBF;AD0BA;EACE,kBAAA;EACA,0CAAA;ACxBF;AD0BA;EACE,iBAAA;EACA,oBAAA;ACxBF;AD0BA;EACE,iBAAA;ACxBF;AD2BA;EACE,SAAA;ACzBF;AD4BA;EACI,YAAA;EACA,4BAAA;EACA,6BAAA;EACA,4BAAA;EACA,+BAAA;EACA,qBAAA;EACA,0CAAA;EACA,gCAAA;EACA,gBAAA;AC1BJ;AD6BA;EACI,qBAAA;EACA,yCAAA;AC3BJ;AD8BA;;EACI,4DAAA;EACA,0DAAA;EACA,4CAAA;EACA,eAAA;AC3BJ;AACA,8CAA8C","sourcesContent":["@input-border: 3px;\n\n@xx-small-font: 10px;\n@x-small-font: 11px;\n@small-font: 12px;\n@medium-font: 13px;\n@large-font: 14px;\n@x-large-font: 18px;\n@xx-large-font: 24px;\n\n@xx-small-size: 40px;\n@x-small-size: 80px;\n@small-size: 120px;\n@medium-size: 200px;\n@large-size: 280px;\n@x-large-size: 480px;\n@xx-large-size: 950px;\n\na.navbar-brand {\n\tpadding-left: 43px;\n\tposition: relative;\n\tobject {\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\ttop: 3px;\n\t\tz-index: -1; /*Fix for logo to be clickable*/\n\t}\n}\n\n.loggedInfo {\n\tcolor: white;\n\tpadding-top: 9px;\n}\n\n#repositorySelectDropdown {\n  .fa {\n    color: #fff;\n  }\n  &.open > .popover {\n    display: none !important;\n  }\n  li .popover {\n    .popover-title {\n      padding: 4px 14px;\n    }\n    .popover-content {\n      padding: 6px 14px\n    }\n    label {\n      margin-bottom: 3px;\n    }\n  }\n}\n\n#menu-active-location {\n  max-width: 146px;\n  overflow: hidden;\n  display: inline-block;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  cursor: default;\n  margin-bottom: -4px;\n  font-size: 0.9em;\n  padding-left: 5px;\n\n  @media (min-width:1030px) {\n    max-width: 180px;\n  }\n\n  @media (min-width:1080px) {\n    max-width: 230px;\n  }\n\n  @media (min-width:1130px) {\n    max-width: 280px;\n  }\n\n  @media (min-width:1180px) {\n    max-width: 330px;\n  }\n\n  @media (min-width:1230px) {\n    max-width: 380px;\n  }\n\n  @media (min-width:1280px) {\n    max-width: 430px;\n  }\n\n  @media (min-width: 1440px) {\n    max-width: 520px;\n  }\n}\n\n.activeRepositorySYSTEM {\n  & > .popover {\n    width: 250px;\n    .popover-title {\n      display: none;\n    }\n    .popover-content .row {\n      display: none;\n      &:first-child {\n        display: block;\n      }\n    }\n  }\n}\n.chooseRepository > .popover {\n  display: none !important;\n}\n.activeRepository > .popover {\n  width: 250px;\n}\n\n// Change the z-index to show the popovers above the navigation bars\n.popover {\n    z-index: 2060;\n}\n\n\n[ng-cloak] + .show-ng-cloak {\n\tdisplay: block !important;\n}\n\n.wb-pointer {\n  cursor: pointer;\n}\n\n.wb-home-data h4 {\n  color: #000;\n}\n\ntd .editable-wrap {\n\tdisplay: inline;\n}\n\n.navbar-fixed-top .container > .navbar-header, .navbar-fixed-top .container > .navbar-collapse {\n  margin-right: 0;\n  margin-left: 0;\n  display: block;\n  border-top: 0;\n}\n.navbar-fixed-top .navbar-header, .navbar-fixed-top .navbar-nav, .navbar-fixed-top .navbar-nav > li {\n  float: left;\n}\n.navbar-fixed-top .navbar-nav.navbar-right {\n  float: right;\n  margin-right: -15px;\n}\n.navbar-fixed-top .navbar-nav .open .dropdown-menu {\n  position: absolute;\n  background-color: var(--gw-secondary-base);\n}\n.navbar-fixed-top .navbar-nav > li > a {\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n.navbar-fixed-top .navbar-text {\n  margin-left: 15px;\n}\n\n.navbar-nav {\n  margin: 0;\n}\n\n.navbar-button {\n    color: white;\n    padding-left: 7px !important;\n    padding-right: 7px !important;\n    padding-top: 12px !important;\n    padding-bottom: 12px !important;\n    text-decoration: none;\n    background-color: var(--gw-secondary-base);\n    display: inline-block !important;\n    margin-left: 7px;\n}\n\n.navbar-button:hover {\n    text-decoration: none;\n    background-color: var(--gw-tertiary-base);\n}\n\n.autocomplete-toast a, .autocomplete-toast a:hover {\n    background-color: var(--gw-toast-warn-background) !important;\n    border-color: var(--gw-toast-warn-border-color) !important;\n    color: var(--gw-toast-warn-color) !important;\n    cursor: pointer;\n}\n","a.navbar-brand {\n  padding-left: 43px;\n  position: relative;\n}\na.navbar-brand object {\n  position: absolute;\n  left: 0;\n  top: 3px;\n  z-index: -1;\n  /*Fix for logo to be clickable*/\n}\n.loggedInfo {\n  color: white;\n  padding-top: 9px;\n}\n#repositorySelectDropdown .fa {\n  color: #fff;\n}\n#repositorySelectDropdown.open > .popover {\n  display: none !important;\n}\n#repositorySelectDropdown li .popover .popover-title {\n  padding: 4px 14px;\n}\n#repositorySelectDropdown li .popover .popover-content {\n  padding: 6px 14px;\n}\n#repositorySelectDropdown li .popover label {\n  margin-bottom: 3px;\n}\n#menu-active-location {\n  max-width: 146px;\n  overflow: hidden;\n  display: inline-block;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  cursor: default;\n  margin-bottom: -4px;\n  font-size: 0.9em;\n  padding-left: 5px;\n}\n@media (min-width: 1030px) {\n  #menu-active-location {\n    max-width: 180px;\n  }\n}\n@media (min-width: 1080px) {\n  #menu-active-location {\n    max-width: 230px;\n  }\n}\n@media (min-width: 1130px) {\n  #menu-active-location {\n    max-width: 280px;\n  }\n}\n@media (min-width: 1180px) {\n  #menu-active-location {\n    max-width: 330px;\n  }\n}\n@media (min-width: 1230px) {\n  #menu-active-location {\n    max-width: 380px;\n  }\n}\n@media (min-width: 1280px) {\n  #menu-active-location {\n    max-width: 430px;\n  }\n}\n@media (min-width: 1440px) {\n  #menu-active-location {\n    max-width: 520px;\n  }\n}\n.activeRepositorySYSTEM > .popover {\n  width: 250px;\n}\n.activeRepositorySYSTEM > .popover .popover-title {\n  display: none;\n}\n.activeRepositorySYSTEM > .popover .popover-content .row {\n  display: none;\n}\n.activeRepositorySYSTEM > .popover .popover-content .row:first-child {\n  display: block;\n}\n.chooseRepository > .popover {\n  display: none !important;\n}\n.activeRepository > .popover {\n  width: 250px;\n}\n.popover {\n  z-index: 2060;\n}\n[ng-cloak] + .show-ng-cloak {\n  display: block !important;\n}\n.wb-pointer {\n  cursor: pointer;\n}\n.wb-home-data h4 {\n  color: #000;\n}\ntd .editable-wrap {\n  display: inline;\n}\n.navbar-fixed-top .container > .navbar-header,\n.navbar-fixed-top .container > .navbar-collapse {\n  margin-right: 0;\n  margin-left: 0;\n  display: block;\n  border-top: 0;\n}\n.navbar-fixed-top .navbar-header,\n.navbar-fixed-top .navbar-nav,\n.navbar-fixed-top .navbar-nav > li {\n  float: left;\n}\n.navbar-fixed-top .navbar-nav.navbar-right {\n  float: right;\n  margin-right: -15px;\n}\n.navbar-fixed-top .navbar-nav .open .dropdown-menu {\n  position: absolute;\n  background-color: var(--gw-secondary-base);\n}\n.navbar-fixed-top .navbar-nav > li > a {\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n.navbar-fixed-top .navbar-text {\n  margin-left: 15px;\n}\n.navbar-nav {\n  margin: 0;\n}\n.navbar-button {\n  color: white;\n  padding-left: 7px !important;\n  padding-right: 7px !important;\n  padding-top: 12px !important;\n  padding-bottom: 12px !important;\n  text-decoration: none;\n  background-color: var(--gw-secondary-base);\n  display: inline-block !important;\n  margin-left: 7px;\n}\n.navbar-button:hover {\n  text-decoration: none;\n  background-color: var(--gw-tertiary-base);\n}\n.autocomplete-toast a,\n.autocomplete-toast a:hover {\n  background-color: var(--gw-toast-warn-background) !important;\n  border-color: var(--gw-toast-warn-border-color) !important;\n  color: var(--gw-toast-warn-color) !important;\n  cursor: pointer;\n}\n/*# sourceMappingURL=owlim-workbench.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
